<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                        <!-- <img src="/img/noimage.png" class="rounded-circle"> -->
                                        <img style="max-width:250px" v-if="form.logo === ''" src="/img/noimage.png">
                                        <img style="max-width:250px" v-if="form.logo !== ''" :src="form.logo.thumbnail">
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                                <!-- <base-button size="sm" type="info" class="mr-4">Connect</base-button>
                                <base-button size="sm" type="default" class="float-right">Message</base-button> -->
                            </div>
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5" style="margin-bottom:50px">
                                        <!-- <div>
                                            <span class="heading">22</span>
                                            <span class="description">Friends</span>
                                        </div>
                                        <div>
                                            <span class="heading">10</span>
                                            <span class="description">Photos</span>
                                        </div>
                                        <div>
                                            <span class="heading">89</span>
                                            <span class="description">Comments</span>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div style="margin-bottom:50px">
                                    <base-button @click="Delete('ImgProfile')" v-if="form.photo !== ''" type="danger">{{$t('delete_image')}}</base-button><br /><br />
                                    <div class="custom-file">
                                        <input type="file" accept="image/*" name="profile_img" id="profile_img" ref="profile_img" v-on:change="onFileChanged()" class="custom-file-input">
                                        <label class="custom-file-label" for="profile_img">{{$t('change_image')}}</label>
                                    </div>
                                </div>
                                <div class="h5 mt-4">
                                    {{$t('createdAt')}} : {{ form.created_at | luxon }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">{{$t('gym')}}</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <!-- <a href="#!" class="btn btn-sm btn-primary">Settings</a> -->
                                </div>
                            </div>
                        </div>
                        <template>
                            <ValidationObserver v-slot="{ passes }">
                            <form @submit.prevent="passes(onSubmit)">
                                <h6 class="heading-small text-muted mb-4">{{$t('user_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('gym_name')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('gym_name')"
                                                        rules="required"
                                                        :placeholder="$t('gym_name')"
                                                        v-model="form.name">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('branch')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('branch')"
                                                        rules="required"
                                                        :placeholder="$t('branch')"
                                                        v-model="form.branch">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('description')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('description')"
                                                        rules="required|min:4"
                                                        :placeholder="$t('description')"
                                                        v-model="form.description">
                                            </base-input>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">{{$t('contact_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('address')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('address')"
                                                        rules="required|min:4"
                                                        :placeholder="$t('address')"
                                                        v-model="form.address">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('phone')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('phone')"
                                                        rules="required|min:9"
                                                        :placeholder="$t('phone')"
                                                        v-model="form.contact_no">
                                            </base-input>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="text-right">
                                    <base-button nativeType="submit" type="primary" class="my-4">{{$t('save')}}</base-button>
                                </div>
                            </form>
                        </ValidationObserver>
                        </template>
                    </card>
                </div>
            </div>
        </div>

        <modal :show.sync="modal_confirm">

            <p>{{$t('confirm_delete')}}</p>

            <template slot="footer">
                <base-button @click="modal_confirm = false" type="primary">{{$t('cancel')}}</base-button>
                <base-button v-if="type_delete === 'ImgProfile'" @click="DeleteImgProfile()" type="danger">{{$t('delete')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal_success">

            <p>{{$t('confirm_success')}}</p>

            <template slot="footer">
                <base-button @click="modal_success = false" type="primary">{{$t('close')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
// import i18n from "@/i18n"
  export default {
    name: 'gym',
    components: {
        ValidationObserver
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        modal_confirm: false,
        modal_success: false,
        profile_img_file: '',
        type_delete: '',
        form: {
          name: '',
          logo: '',
          branch: '',
          description: '',
          address: '',
          contact_no: ''
        }
      }
    },
    created () {
      this.ListItem()
    },
    methods: {
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        Delete (type) {
            this.modal_confirm = true
            this.type_delete = type
        },
        onFileChanged () {
            this.profile_img_file = this.$refs.profile_img.files[0]
            this.submitFile()
        },
        submitFile () {
            let formData = new FormData()
            formData.append('file', this.profile_img_file)
            this.$http.post('gyms/logo',
            formData)
            .then(request => this.AddImageSuccessful(request))
            .catch()
        },
        AddImageSuccessful () {
            this.ListItem()
        },
        ListItem () {
            this.$http.get('gyms')
            .then(request => this.ListItemSuccessful(request))
            .catch(() => this.ListItemFailed())
        },
        ListItemSuccessful (req) {
            if (req.data.code !== '0') {
                this.ListItemFailed(req)
                return
            }
            this.form = req.data.data
            if(req.data.data.logo === undefined) {
                this.form.logo = ''
            }
        },
        ListItemFailed (req) {
            this.modalAlert(req)
        },
        onSubmit () {
            this.$http.patch('gyms', {
                "name": this.form.name,
                "branch": this.form.branch,
                "description": this.form.description,
                "address": this.form.address,
                "contact_no": this.form.contact_no
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.modal_success = true
            this.ListItem()
        },
        onSubmitFailed (req) {
            this.modalAlert(req)
        },
        DeleteImgProfile () {
            this.modal_confirm = false
            this.$http.delete('gyms/logo')
            .then(request => this.DeleteImgProfileSuccessful(request))
            .catch(() => this.DeleteImgProfileFailed())
        },
        DeleteImgProfileSuccessful (req) {
            if (req.data.code !== '0') {
            this.DeleteImgProfileFailed(req)
            return
            }
            this.form.photo = ''
        },
        DeleteImgProfileFailed (req) {
            this.modalAlert(req)
        }
    }
  };
</script>
<style></style>
